import { LineClamp } from "@newsela/angelou";
import { IStandard } from "@/search/NewSearchPageMVP/types/IStandard";
import {
  standardGradesAndYearCss,
  standardInfoCss,
  standardRegionAndTitleCss,
  standardsSetRowCss,
  standardSubjectCss,
} from "./StandardItem.styles";
import { StandardItemButtons } from "./StandardItemButtons";

interface IStandardItemProps {
  standard: IStandard;
}

export const StandardItem = ({ standard }: IStandardItemProps) => {
  const {
    description,
    display_fields: {
      authority_description: authorityDescription,
      grades,
      document_adopt_year: documentAdoptYear,
      document_primary_subject: documentPrimarySubject,
      number_enhanced: numberEnhanced,
    },
  } = standard;

  return (
    <li css={standardsSetRowCss}>
      <div css={standardInfoCss}>
        <span css={standardGradesAndYearCss}>
          Grades: {grades.join(", ")} | {documentAdoptYear} |{" "}
          {documentPrimarySubject}
        </span>
        <span css={standardSubjectCss}>{numberEnhanced}</span>
        <LineClamp
          lines={1}
          text={`${authorityDescription} | ${description}`}
          innerElement="span"
          css={standardRegionAndTitleCss}
        />
      </div>
      <StandardItemButtons standard={standard} />
    </li>
  );
};
